import React from 'react';
import './Chapters.scss';

function Chapter2() {
  return (
    <>
      <section className="chapter">
        <p className="chapter__paragraph">
          Hartshorn’s team was scrambling to organize their response when they received a call from
          a longstanding partner. “Intel called us. And they said, ‘We've got to do something
          here,’” Hartshorn says. The question was how? “At that point, we had no resources to
          support refugees in the region. No money, no equipment, no identified partners.” What they
          did have was a new collaborative venture called{' '}
          <a
            href="https://www.n50project.org/"
            target="_blank"
            rel="sponsored"
            style={{ color: '#3873CA', fontFamily: 'cnnSansB' }}
          >
            The N50 Project,
          </a>{' '}
          tasked with leveraging the expertise of Intel, Geeks Without Frontiers, and other industry
          leaders.
        </p>
        <p className="chapter__paragraph">
          Less than five weeks later, their will to help found a way: the first Portable
          Connectivity Center, a fully-kitted out shipping container offering connection and comfort
          to displaced Ukrainians, was delivered to a refugee center in Bucharest, Romania.
        </p>
        <p className="chapter__paragraph">This is the story of how it all came together.</p>
      </section>
    </>
  );
}

export default Chapter2;
